<template>
  <div class="">
    <div :class="`video_box${style_t}`" v-video-player:myVideoPlayer="playerOptions"  @ended="onPlayerEnded($event)"  @play="onPlayerPlay($event)"></div>
    <!-- <video-player  :class="`video_box${style_t}`"
  ref="videoPlayer" 
  :playsinline="true"
  @play="onPlayerPlay($event)"
  @ended="onPlayerEnded($event)" 
  :options="playerOptions"
></video-player> -->
  </div>
</template>

<script>


import Vue from 'vue';
const VueVideoPlayer= require('vue-video-player/dist/ssr');
const hls = require('videojs-contrib-hls');
import 'vue-video-player/src/custom-theme.css';
// import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-flash';
// const SWF_URL=require('videojs-swf/dist/video-js.swf');

// Video.options.flash.swf = SWF_URL; // 设置flash路径，Video.js会在不支持html5的浏览中使用flash播放视频文件
// videojs.addLanguage('zh-CN', zhCN);
Vue.use(hls);
Vue.use(VueVideoPlayer);
export default {
        props: {
      src: { // 视频url
        type: String,
        default: ''
      },
      poster: { //封面地址
        type: String,
        default: ''
      },
      style_t: { //样式类型
        type: Number,
        default: 1
      }
    },
    data(){
      return {
            playerOptions:{
              controls:false,
      playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
      autoplay: false, // 如果为true,浏览器准备好时开始回放。
      muted: false, // 默认情况下将会消除任何音频。
      loop: false, // 是否视频一结束就重新开始。
      preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      language: 'zh-CN',
      aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      hls: true,
      sources: [{
        src: this.src // url地址
      }],
      poster: this.poster , // 封面地址
      notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
      controlBar: {
        volumePanel: {
          inline: false //音量调节是否水平
        },
        timeDivider: true, // 当前时间和持续时间的分隔符
        durationDisplay: true, // 显示持续时间
        remainingTimeDisplay: false, // 是否显示剩余时间功能
        fullscreenToggle: true // 是否显示全屏按钮
      }
    }
      }
    },
    mounted(){
      // 监控视频结束时
        this.myVideoPlayer.on('ended',()=>{
            this.$emit('end')
        })
    },
    methods:{
      // 
      onPlayerPlay(){
       
      },
      onPlayerEnded(){
      
      },
       _initVideoPlaye () {
      const Player =this.myVideoPlayer;
      
      Player.src(this.$props.src);
      Player.play();
      Player.poster(this.$props.poster)
    }

    }
}

</script>

<style scoped>
  .video_box2 >>>.vjs-fluid{padding-top: calc(100vh - 60px)!important;}
  >>> .vjs-slider-vertical .vjs-volume-level:before {left:-0.45em}
  >>> .video-js .vjs-play-progress:before {top:-0.4em}
  >>> .video-js .vjs-big-play-button {transform:translate(-50%, -50%); left:50%; top:50%; width:2.5em; line-height:2.5em; height:2.5em; border-radius:100px; border:0.06666em solid rgba(255, 255, 255, .8)}
  >>> .video-js:hover .vjs-big-play-button, .vjs-custom-skin > .video-js .vjs-big-play-button:focus, .vjs-custom-skin > .video-js .vjs-big-play-button:active {background:rgba(0, 0, 0, .6)}
</style>
